import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border-light)]">
      <div className="container">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <img 
              src={COMPANY_INFO.logo} 
              alt={COMPANY_INFO.name} 
              className="h-14 w-auto mb-5"
            />
            <p className="body-regular text-[var(--text-secondary)] max-w-sm mb-4 leading-relaxed">
              Canada's premium, carbon-neutral mat rental program. Elevating first impressions 
              and improving safety for businesses across Canada.
            </p>
            <p className="body-small text-[var(--text-light)]">
              Safety • Health • Environment
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[15px] font-semibold text-[var(--text-primary)] mb-5">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/" 
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/shop" 
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                Shop Mats
              </Link>
              <Link 
                to="/custom-quote" 
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                Custom Quote
              </Link>
              <a 
                href={COMPANY_INFO.serviceAgreementPdf}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                Service Agreement
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[15px] font-semibold text-[var(--text-primary)] mb-5">Contact</h4>
            <div className="flex flex-col gap-3">
              <a 
                href="tel:1-877-720-6287" 
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                1-877-720-6287
              </a>
              <a 
                href="mailto:info@executivemat.com" 
                className="text-[15px] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
              >
                info@executivemat.com
              </a>
              <p className="text-[15px] text-[var(--text-secondary)]">
                Canadian Owned & Operated
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[var(--border-light)] py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="body-small text-[var(--text-light)]">
            © {new Date().getFullYear()} Executive Mat Service. All rights reserved.
          </p>
          <p className="body-small text-[var(--text-light)]">
            ISO14001 & COR Safety Certified
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
